import { ReactElement, RefObject } from 'react';
import { LayoutContext, LAYOUT_FLAT, LAYOUT_POINTY } from './LayoutContext';
import { Size } from './base/Point';

import {
  calculateCoordinates,
  defaultOrigin,
  defaultSize,
  defaultSpacing,
} from './LayoutContext';

export type LayoutProps = {
  children: ReactElement | ReactElement[] | JSX.Element | JSX.Element[];
  className?: string;
  id?: string;
  innerRef?: RefObject<HTMLDivElement>;
  flat?: boolean;
  origin?: any;
  /* defines scale */
  size?: Size;
  space?: number;
  spacing?: number;
};

/**
 * Provides LayoutContext for all descendands and renders child elements inside an  element
 */
export function HtmlLayout({
  size = defaultSize,
  flat = true,
  spacing = defaultSpacing,
  origin = defaultOrigin,
  children,
  className,
  innerRef,
  id,
}: LayoutProps) {
  const orientation = flat ? LAYOUT_FLAT : LAYOUT_POINTY;
  const angle = flat ? 0 : Math.PI / 6;
  const cornerCoords = calculateCoordinates(size.x, angle);
  const points = cornerCoords.map((point) => `${point.x},${point.y}`).join(' ');
  const childLayout = {
    orientation,
    size,
    origin,
    spacing,
  };

  return (
    <LayoutContext.Provider
      value={{
        layout: childLayout,
        points,
      }}
    >
      <div ref={innerRef} className={className} id={id}>
        {children}
      </div>
    </LayoutContext.Provider>
  );
}

HtmlLayout.whyDidYouRender = true;
export default HtmlLayout;
